// extracted by mini-css-extract-plugin
export default {"message":"Alert_message__4J4Vr"};